<template>
    <div class="header">
      <div class="header-content flexBetween">
        <div class="header-logo">
          <router-link to="/">
            <img src="../../assets/images/newicon/logo.png" alt="logo" />
          </router-link>
        </div>
        <div class="flexBetween shrink lab-content">
          <div class="header-nav flex shark">
            <div v-for="item in routerList" 
                :key="item.id"
                @click="handleRouter(item)" 
                class="header-nav-item"
                :class="currentPath === item.nameEn?'active':''">
              <router-link tag="li" :to="item.path" >{{item.name}}</router-link>
            </div>
          </div>
          <ul class="header-user flex">
            <div v-if="isLogin" class="">
              <span @click="openPublishPositionWeb" class="header-user-item">我要招人</span>
              <span @click="goMyresume" class="header-user-item">我的简历</span>
              <span @click="goMyIntro" class="header-user-item">兜售自己</span>
              <el-dropdown @command="handleCommand" >
                <!-- <router-link
                  tag="li"
                  :to="{ name: 'myDeliveredResume' }"
                  class="header-user-item"
                >
                  <img
                    :src="user.avatarUrl || defaultAvatar"
                    alt="avatar"
                    class="header-avatar"
                  />
                  {{ user.name }}
                </router-link> -->
                <div class="login-user-name"><img
                    :src="user.avatarUrl || defaultAvatar"
                    alt="avatar"
                    class="header-avatar"
                  />
                  {{ user.name }}</div>
                <el-dropdown-menu slot="dropdown" style="width: 150px;text-align: center;">
                 <!-- <el-dropdown-item command="usercenter">个人中心</el-dropdown-item> -->
                 
                 <!-- <el-dropdown-item command="invite">面试邀请</el-dropdown-item> -->
                 <el-dropdown-item command="feedback" class="flex itemsCenter">
                  <img 
                    src="../../assets/images/login/userfedback.png"  
                    style="width: 24px;height: 24px;margin-right: 6px;"
                    alt=""> 求职反馈</el-dropdown-item>
                 <el-dropdown-item command="collect" class="flex itemsCenter">
                  <img 
                    src="../../assets/images/login/userCollect.png"  
                    style="width: 24px;height: 24px;margin-right: 6px;"
                    alt=""> 
                  我的收藏</el-dropdown-item>
                 <el-dropdown-item command="resume" class="flex itemsCenter">
                  <img 
                    src="../../assets/images/login/userResum.png"  
                    style="width: 24px;height: 24px;margin-right: 6px;"
                    alt=""> 
                    我的简历</el-dropdown-item>
                 <el-dropdown-item command="account" class="flex itemsCenter">
                  <img 
                    src="../../assets/images/login/userOpear.png"  
                    style="width: 24px;height: 24px;margin-right: 6px;"
                    alt=""> 
                    账号设置</el-dropdown-item>
                  <el-dropdown-item command="exit" class="flex itemsCenter">
                    <img 
                    src="../../assets/images/login/userout.png"  
                    style="width: 24px;height: 24px;margin-right: 6px;"
                    alt=""> 
                    退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div v-else class="flex flexCentet">
              <span @click="openPublishPositionWeb" class="header-user-item">我要招人</span>
              <router-link
                  tag="li"
                  to="/login"
                  class="header-user-item"
                  v-if="!isLogin">我要找工作</router-link>
              <!-- <span class="header-user-item"></span> -->
              <router-link
                  tag="li"
                  to="/login"
                  class="header-user-item"
                  v-if="!isLogin">登录</router-link>
              <!-- <div class="loginOut">退出</div> -->
              <!-- <router-link
                tag="li"
                to="/register"
                class="header-user-item"
                v-if="!isLogin"></router-link> -->
            </div>
            
          </ul>
      </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState, mapGetters, mapActions } from "vuex";
  // import defaultAvatar from "../../assets/images/default-avatar.png";
  import defaultAvatar from "../../assets/images/newicon/login.png";
  export default {
    data() {
      return {
        routerList:[
          {id:1,name:'主页',path:'/',nameEn:"index"},
          {id:2,name:'职位',path:'/job',nameEn:"job"},
          {id:3,name:'在招公司',path:'/company',nameEn:"company"},
          {id:4,name:'专场招聘',path:'/session',nameEn:"session"},
          {id:5,name:'小程序',path:'/weapp',nameEn:"weapp"},
          {id:6,name:'关于我们',path:'/about',nameEn:"about"},
          // {id:7,name:'我要招人',path:'',nameEn:"find"},
          
        ],
        currentPath:'index'

      };
    },
    created(){},
    computed: {
      ...mapGetters(["isLogin"]),
      ...mapState({
        user: state => state.user.info
      }),
      defaultAvatar() {
        return defaultAvatar;
      }
    },
    methods: {
      ...mapActions(["loginout"]),
      handleCommand(command) {
        let obj={
          'usercenter':'myDeliveredResume',
          'collect':'myCollect',
          'invite':'myInvite',
          'feedback':'myFeedback',
          'resume':'myresume',
          'account':'myAccount'
        }
        if (command === "exit") {
          this.$confirm("退出登录, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.loginout();
            this.$router.push("/");
            window.localStorage.removeItem("token");
          });
        }else{
          this.$router.replace({ name: obj[command] });
        }
      },
      handleRouter(item){
        if(item.path){
          this.currentPath = item.nameEn
        }else{
          window.open("https://www.selfhelp.itneituiquan.com", "_blank");
        }
      },
      goMyresume() {
        if (!this.isLogin) {
          this.$router.push("/login");
        } else {
          this.$router.push("/myresume");
        }
      },
      goMyIntro() {
        if (!this.isLogin) {
          this.$router.push("/login");
        } else {
          this.$router.push("/myintro");
        }
      },
      gotoPdf() {
        window.location.href = "https://attachment.itneituiquan.com/faq/FAQ.pdf";
      },
      openPublishPositionWeb() {
        // window.open("https://www.selfhelp.itneituiquan.com", "_blank");
        window.open("https://www.selfhelp.itneituiquan.com", "_self");
        
      }
    },
    watch:{
      '$route':{
        handler(newVal){
          console.log(newVal,"监听路由66666")
          this.currentPath = newVal.name;
        },
        immediate:true
      }
		},
  };
  </script>
  
  <style lang="less" rel="stylesheet/less">
    @mianColor:#287CF3;
    @whiteColor:#fff;
    @mainFontCol:rgba(255, 255, 255, .6);
    .header-logo{
      line-height: 0;
      img{
        width: 146px;
      }
      
    }
  .header {
    height: 66px;
    background-color: rgba(11, 35, 66, 1);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
    .lab-content{
      width: 82%;
      flex-wrap: nowrap;
    }
    &-avatar {
      display: inline;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      vertical-align: middle;
    }
    &-content {
      width: 1280px;
      margin: 0 auto;
      height: 100%;
    }
    &-nav {
      list-style: none;
      overflow: hidden;
      height: 100%;
      &-item {
        color: @mainFontCol;
        line-height: 56px;
        margin: 0 18px;
        // padding: 0 10px;
        cursor: pointer;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        transition: all 0.2s ease-in-out 0s;
        &:hover {
          color: @whiteColor;
          font-weight: 500;
        }

      }
      .active {
          color: @whiteColor;
          font-weight: 500;
          &::after {
            content: "";
            position: absolute;
            width: 100%;
            height: 4px;
            background-color: @whiteColor;
            left: 0;
            bottom: 8px;
          }
        }
    }
    &-user {
      margin: 0;
      padding: 0;
      list-style: none;
      height: 100%;
      &-item {
        height: 100%;
        line-height: 56px;
        padding: 0 0 0 24px;
        cursor: pointer;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        position: relative;
        color: @whiteColor;
      }
    }
    .loginOut{
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      margin-left: 20px;
      cursor: pointer;

    }
    .login-user-name{
      color: #fff;
      margin-left: 20px;
      cursor: pointer;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }
  }

  </style>
  